import * as React from "react"
import {Drawer} from "@mui/material";

import {SimpleScrollbar} from "..";
import {dsColorNew} from "@palette";

export default function BaseDesktopDrawer({ children, scrollbarProps={} , ...props }) {
    return <Drawer
        open
        variant="permanent"
        {...props}
        PaperProps={{
            ...props?.PaperProps,
            sx: {
                backgroundColor: dsColorNew.navy,
                borderRight: 'none',
                ...props?.PaperProps?.sx
            }
        }}
    >
        <SimpleScrollbar {...scrollbarProps}>
            {children}
        </SimpleScrollbar>
    </Drawer>
}